import React from 'react';
import QawaemErpListPageShell from '../../../products/saudi/components/QawaemErpListPageShell';
import { mapInventaireStatCards } from '../inventaireListPageUtils';

/**
 * Thin wrapper around QawaemErpListPageShell for inventaire list pages.
 * Matches المنتجات (Products) list chrome: title filters, 4 KPIs, import/export, glass table shell.
 */
export default function InventaireListPageShell({
  title,
  subtitle,
  icon,
  statEntries = [],
  viewMode,
  onViewModeChange,
  searchTerm,
  onSearchChange,
  searchPlaceholder,
  filterActions = null,
  onCreate,
  createLabel,
  importExport,
  children,
}) {
  const stats = mapInventaireStatCards(statEntries);

  return (
    <QawaemErpListPageShell
      title={title}
      subtitle={subtitle}
      icon={icon}
      stats={stats}
      viewMode={viewMode}
      onViewModeChange={onViewModeChange}
      filterActions={filterActions}
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
      searchPlaceholder={searchPlaceholder}
      onCreate={onCreate}
      createLabel={createLabel}
      importExport={importExport}
    >
      {children}
    </QawaemErpListPageShell>
  );
}
